import Topbar from '@components/topbar';
import useSumSubSDK from '@hooks/query/kyc/useSumSubSDK';
import SumsubWebSdk from '@sumsub/websdk-react';
import SumsubWebSdkProps from '@sumsub/websdk-react/types/SumsubWebSdkProps';
import React from 'react';
import { useIntl } from 'react-intl';
import { kycNeedChange, TKycStatus } from 'types/authKyc.types';
import { Button } from '@ui';
import { KycVerificationSC } from './kyc-verification.styled';

interface KycVerificationProps {
  onFinished?: () => void;
  kycStatus?: TKycStatus;
  onChangeRequested?: () => void;
}

const KycVerification: React.FunctionComponent<KycVerificationProps> = ({
  onFinished,
  kycStatus,
  onChangeRequested,
}) => {
  const needChange = kycNeedChange(kycStatus);
  const { kycToken, refreshSdkToken } = useSumSubSDK();
  const { locale, formatMessage } = useIntl();

  const messageHandler: NonNullable<SumsubWebSdkProps['onMessage']> = React.useCallback(
    (message) => {
      if (message === 'idCheck.actionCompleted' || message === 'idCheck.applicantStatus') {
        onFinished?.();
      }
    },
    [],
  );
  const errorHandler: NonNullable<SumsubWebSdkProps['onError']> = React.useCallback((message) => {
    console.log('err', message);
  }, []);

  return (
    <>
      <Topbar />
      <KycVerificationSC variant="background">
        {kycToken ? (
          <SumsubWebSdk
            accessToken={kycToken}
            expirationHandler={refreshSdkToken}
            config={{
              lang: locale,
              uiConf: {
                scrollIntoView: true,
              },
            }}
            options={{ addViewportTag: false, adaptIframeHeight: true }}
            onMessage={messageHandler}
            onError={errorHandler}
          />
        ) : null}
      </KycVerificationSC>
      {needChange ? (
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Button
            variant="primary"
            type="button"
            size="large"
            onClick={onChangeRequested}
            block={false}
            leftArrow
          >
            {formatMessage({ id: 'kyc.changeAction' })}
          </Button>
        </div>
      ) : null}
    </>
  );
};

export default KycVerification;
